const MAX_PADDING_X_PX = 32
const MAX_CONTENT_WIDTH_PX = 1240
const MAX_W = `${MAX_CONTENT_WIDTH_PX + 2 * MAX_PADDING_X_PX}px`

export default {
  baseStyle: {
    display: 'block',
    width: '100%',
    maxWidth: MAX_W,
    m: '0 auto',
    p: { base: '16px', md: '24px', lg: `${MAX_PADDING_X_PX}px` },
  },
}
